import { Eyebrow, MaskedLine, Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";
import { useContent } from "../lib/content";
import { LEGAL_META } from "../data/legal";

function parseLegal(raw) {
  const sections = [];
  let current = null;
  for (const line of (raw || "").split("\n")) {
    const t = line.trim();
    if (!t) continue;
    if (t.startsWith("# ")) {
      current = { heading: t.slice(2), body: [] };
      sections.push(current);
    } else if (current) {
      current.body.push(t);
    } else {
      sections.push({ heading: "", body: [t] });
    }
  }
  return sections;
}

export default function LegalPage({ docKey }) {
  const { content } = useContent();
  const meta = LEGAL_META[docKey];
  const sections = parseLegal(content.legal?.[docKey]);

  return (
    <div data-testid={`legal-${docKey}-page`}>
      <SEO title={meta.seoTitle} description={meta.seoDescription} />
      <section className="bg-forest-deep pb-20 pt-44 text-cream">
        <div className="mx-auto max-w-5xl px-6 lg:px-10">
          <Eyebrow light>Legal</Eyebrow>
          <h1 className="mt-8 font-display text-5xl font-medium leading-[0.98] tracking-tight sm:text-6xl" data-testid="legal-headline">
            <MaskedLine delay={0.15}>{meta.title1}</MaskedLine>
            <MaskedLine delay={0.3} className="italic text-gold">
              {meta.title2}
            </MaskedLine>
          </h1>
          <Reveal delay={0.5}>
            <p className="mt-6 text-sm text-cream/60">Rooted Business Advisors, LLC</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-6 py-20 lg:px-10">
        {sections.map((s, i) => (
          <Reveal key={i} delay={0.03}>
            <div className="grid gap-4 border-t border-forest/15 py-10 last:border-b md:grid-cols-12">
              <h2 className="font-display text-2xl font-medium text-forest md:col-span-4">
                {s.heading && (
                  <>
                    <span className="mr-3 font-display text-base italic text-gold">{String(i + 1).padStart(2, "0")}</span>
                    {s.heading}
                  </>
                )}
              </h2>
              <div className="space-y-4 md:col-span-8">
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm leading-relaxed text-sage">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
